import validate from 'validate.js';
import { ARRAY_ERROR } from 'final-form';
import i18n from '../../i18n';
import { FormItemTypes } from './FormItemTypes';
import { FormQuestionTypes } from './FormQuestionTypes';

export const publicSurveySubmissionFormValidation = (values, form, participantsVerification) => {
  const errors = {};

  const formQuestions = form.length > 0
    ? form
      .map(formItem => {
        if (formItem.type === FormItemTypes.question) {
          return [{ id: formItem.id, type: formItem.questionType, questions: formItem.questions, isOptional: formItem.isOptional, choiceLimits: formItem.choiceLimits, maxLength: formItem.maxLength, maxAnswers: formItem.maxAnswers }];
        } else if (formItem.type === FormItemTypes.area) {
          return formItem.questions.map(question => ({ id: question.id, type: question.questionType, questions: question.questions, isOptional: question.isOptional, choiceLimits: question.choiceLimits, maxLength: question.maxLength, maxAnswers: question.maxAnswers }));
        }
      })
      .reduce((previous, current) => (previous.concat(current)))
    : [];

  const answersErrors = [];
  values.answers.forEach((answer, index) => {
    const itemErrors = { selectedAnswersIds: [], ownAnswers: [] };

    const formQuestion = formQuestions.find(q => q.id === answer.questionId);

    if (formQuestion.type === FormQuestionTypes.singleChoiceTable) {
      if (formQuestion.isOptional && (!answer.selectedAnswersIds || answer.selectedAnswersIds.length === 0)) return;

      if (!answer.selectedAnswersIds || answer.selectedAnswersIds.filter(a => a != null).length !== formQuestions.find(q => q.id === answer.questionId).questions.length) {
        itemErrors.selectedAnswersIds[ARRAY_ERROR] = i18n.t('common.validation.allRequired');
      }
      if (answer.selectedAnswersIds) {
        answer.selectedAnswersIds.forEach((value, index) => {
          if (value === 'own' && (!answer.ownAnswers || !answer.ownAnswers[index])) {
            itemErrors.ownAnswers[index] = i18n.t('common.validation.required');
          }
        });
      }
    } else if (formQuestion.type === FormQuestionTypes.locationsProposal) {
      if (!formQuestion.isOptional && (!answer.locations || !answer.locations.proposed || !answer.locations.existing)) {
        itemErrors.locations = i18n.t('common.validation.required');
      } else if (!formQuestion.isOptional
        && ((answer.locations.proposed || []).length + (answer.locations.existing || []).length < formQuestion.choiceLimits.min
          || (answer.locations.proposed || []).length + (answer.locations.existing || []).length > formQuestion.choiceLimits.max)) {
        itemErrors.locations = 'Nie zaznaczono odpowiedniej ilości punktów';
      }
    } else if (formQuestion.type === FormQuestionTypes.freeText) {
      if (!formQuestion.isOptional && !answer.answerText) {
        itemErrors.answerText = i18n.t('common.validation.required');
      }
      if (answer.answerText && formQuestion.maxLength && answer.answerText.length > formQuestion.maxLength) {
        itemErrors.answerText = i18n.t('common.validation.maxLength', { currentLength: answer.answerText.length, maxLength: formQuestion.maxLength });
      }
    } else if (formQuestion.type === FormQuestionTypes.filesUpload) {
      const files = answer.files;
      if (files.some(f => f.failed)) {
        itemErrors.files = i18n.t('surveySubmission.validation.invalidFilesAttached');
      } else if (files.some(f => f.inProgress)) {
        itemErrors.files = i18n.t('surveySubmission.validation.fileInProgress');
      } else if (!formQuestion.isOptional && !files.some(f => f.uploaded)) {
        itemErrors.files = i18n.t('surveySubmission.validation.requiredFilesNotAttached');
      }
    } else {
      if (!formQuestion.isOptional && (!answer.selectedAnswersIds || answer.selectedAnswersIds.length === 0)) {
        itemErrors.selectedAnswersIds[ARRAY_ERROR] = i18n.t('common.validation.required');
        itemErrors.selectedAnswersIds[0] = i18n.t('common.validation.required');
      }

      if (answer.selectedAnswersIds && answer.selectedAnswersIds.includes('own') && (!answer.ownAnswers || !answer.ownAnswers[0])) {
        itemErrors.ownAnswers[0] = i18n.t('common.validation.required');
      }

      if (formQuestion.maxAnswers && answer.selectedAnswersIds && answer.selectedAnswersIds.length > formQuestion.maxAnswers) {
        itemErrors.selectedAnswersIds[ARRAY_ERROR] = i18n.t('common.validation.tooManySelected', { max: formQuestion.maxAnswers });
        itemErrors.selectedAnswersIds[0] = i18n.t('common.validation.tooManySelected', { max: formQuestion.maxAnswers });
      }

      if (formQuestion.minAnswers && answer.selectedAnswersIds && answer.selectedAnswersIds.length > 0 && answer.selectedAnswersIds.length < formQuestion.minAnswers) {
        itemErrors.selectedAnswersIds[ARRAY_ERROR] = i18n.t('common.validation.tooFewSelected', { max: formQuestion.minAnswers });
        itemErrors.selectedAnswersIds[0] = i18n.t('common.validation.tooFewSelected', { max: formQuestion.minAnswers });
      }
    }

    answersErrors[index] = itemErrors;
  });

  if (answersErrors.length) {
    errors.answers = answersErrors;
  }

  const respondentProfileErrors = [];
  values.respondentProfileValues.forEach((value, index) => {
    const itemErrors = {};

    if (!value.valueText && !value.selectedOptionId) {
      itemErrors.selectedOptionId = i18n.t('common.validation.required');
      itemErrors.valueText = i18n.t('common.validation.required');
    }

    respondentProfileErrors[index] = itemErrors;
  });

  if (respondentProfileErrors.length) {
    errors.respondentProfileValues = respondentProfileErrors;
  }
  
  if (participantsVerification && participantsVerification.email && !values.emailToVerify) {
    errors.emailToVerify = i18n.t('common.validation.required');
  }

  return errors;
};

export const newThreadValidation = values => {
  const constraints = {
    title: {
      presence: { message: i18n.t('common.validation.required') },
    },
    content: {
      presence: { message: i18n.t('common.validation.required') },
    },
  };

  return validate(values, constraints, { fullMessages: false });
};

export const newPostValidation = values => {
  const constraints = {
    content: {
      presence: { message: i18n.t('common.validation.required') },
    },
  };

  return validate(values, constraints, { fullMessages: false });
};



// WEBPACK FOOTER //
// ./src/models/survey/SurveySubmissionValidation.js